import { defineMessages } from 'react-intl';

export default defineMessages({
  exportSelectedItems: {
    defaultMessage: 'Only export the { selectedCount } record(s) that are currently selected',
    id: 'W2eagy',
    description: 'Export Selected Items',
  },
  exportAllItems: {
    defaultMessage: 'Export ALL { count } record(s) that are in view',
    id: 'Kx2a9w',
    description: 'Export All Items',
  },
  exportModalStarted: {
    defaultMessage:
      'Your export has started. This may take a while so feel free to close this window. We will let you know when the export is complete.',
    id: 'mjP1jt',
    description: 'Export Modal Started',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'AxxlWW',
    description: 'Cancel and Close Modal',
  },
  exportButton: {
    defaultMessage: 'Export',
    id: '9zH74J',
    description: 'Export Modal button',
  },
  close: {
    defaultMessage: 'Close',
    id: 'T8XEzQ',
    description: 'Close Modal',
  },
  exportModalTitle: {
    defaultMessage: 'Returns Export',
    id: 'WtUIt8',
    description: 'Returns Export Modal Title',
  },
  gridExportsButton: {
    description: 'Export returns button',
    defaultMessage: 'Export',
    id: 'O5Iako',
  },
});
